import { useLanguageSwitcher } from '@hantecmarket/widget-core'
import { createRouter, createWebHistory } from 'vue-router'

import routes from '@/router/routes'
import { findCmsRoutesPath } from '@/utils/cmsRoutesMap/cmsRoutesMap'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { top: 0 }
  }
})

router.beforeEach((to, from, next) => {
  const lang = to.params.lang || 'en'
  const languageSwitcher = useLanguageSwitcher()

  const validLangs = ['en', 'pt', 'es', 'th', 'ko', 'zh-hans', 'zh-hant', 'jp']

  document.documentElement.lang = lang === 'jp' ? 'ja' : (lang as string)

  if (to.name === 'not-found') {
    next()
    return
  }

  if (to.path.startsWith('/en/')) {
    const newPath = to.path.replace(/^\/en\//, '/')
    next({ path: newPath, params: to.params, query: to.query } as any)
    return
  }

  if (to.path.includes('/blog/')) {
    const routes = findCmsRoutesPath(to.path)

    if (!routes) {
      next({ name: 'not-found' })
      return
    }
  }

  // Ensure trailing slash for all paths except for the 404 route
  if (to.path !== '/:pathMatch(.*)*' && !to.path.endsWith('/')) {
    next({ path: `${to.path}/`, params: to.params, query: to.query } as any)
    return
  }

  if (!validLangs.includes(lang as string)) {
    next({ name: 'not-found', params: to.params })
    return
  }

  if (validLangs.includes(lang as string) && lang !== languageSwitcher.getLocale()) {
    languageSwitcher.setLang(<string>lang)
    window.location.reload()
  }

  if (to.name === 'markets' && (to.params.menu_second === 'markets' || !to.params.menu_second)) {
    next({
      name: 'markets',
      params: { ...to.params, menu_second: 'currencies' }
    })
  }

  if (to.name === 'trading' && (to.params.menu_second === 'trading' || !to.params.menu_second)) {
    next({
      name: 'trading',
      params: { ...to.params, menu_second: 'hantec-global' }
    })
  }

  if (
    to.name === 'learn-to-trade' &&
    (to.params.menu_second === 'learn-to-trade' || !to.params.menu_second)
  ) {
    next({
      name: 'learn-to-trade',
      params: { ...to.params, menu_second: 'learning-hub', menu_fourth: 'what-is-cfd-trading' }
    })
  }

  try {
    next()
  } catch (error: any) {
    if (error.message === '404') {
      next({ name: 'not-found' })
    } else {
      console.error('Error:', error)
      next({ name: 'not-found' })
    }
  }
})
export default router
